import { createReducer, PayloadAction } from "@reduxjs/toolkit";
import { getOrganizationByIdRequest } from "@Store/Organizations/actions";
import {
  approveUserUpdateRequest,
  approveUserUpdateRequestFail,
  approveUserUpdateRequestSuccess,
  declineUserUpdateRequest,
  declineUserUpdateRequestFail,
  declineUserUpdateRequestSuccess,
  setHasPendingRequest,
  userUpdateRequestsListFail,
  userUpdateRequestsListRequest,
  userUpdateRequestsListSuccess,
} from "./actions";
import { IOrgUserUpdateRequest } from "./types";

interface IUserUpdateRequestsState {
  list: IOrgUserUpdateRequest[];
  isLoading: boolean;
  actionInFlight: number | null;
  hasPendingRequest: boolean;
}

const INITIAL_STATE: IUserUpdateRequestsState = {
  list: [],
  isLoading: false,
  actionInFlight: null,
  hasPendingRequest: false,
};

export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(userUpdateRequestsListRequest, (state) => {
      state.isLoading = true;
    })
    .addCase(
      userUpdateRequestsListSuccess,
      (state, action: PayloadAction<IOrgUserUpdateRequest[]>) => {
        state.list = action.payload;
        state.isLoading = false;
        state.hasPendingRequest = action.payload.some(
          (request) => !request.processed
        );
      }
    )
    .addCase(setHasPendingRequest, (state, action: PayloadAction<boolean>) => {
      state.hasPendingRequest = action.payload;
    })
    .addCase(getOrganizationByIdRequest, (state) => {
      state.hasPendingRequest = false;
    })
    .addCase(userUpdateRequestsListFail, (state) => {
      state.isLoading = false;
    })
    .addCase(approveUserUpdateRequest, (state, action) => {
      state.actionInFlight = action.payload.requestId;
    })
    .addCase(approveUserUpdateRequestSuccess, (state) => {
      state.actionInFlight = null;
    })
    .addCase(approveUserUpdateRequestFail, (state) => {
      state.actionInFlight = null;
    })
    .addCase(declineUserUpdateRequest, (state, action) => {
      state.actionInFlight = action.payload.requestId;
    })
    .addCase(declineUserUpdateRequestSuccess, (state) => {
      state.actionInFlight = null;
    })
    .addCase(declineUserUpdateRequestFail, (state) => {
      state.actionInFlight = null;
    });
});
